import { render, staticRenderFns } from "./ApprovalCategory.vue?vue&type=template&id=e68c92ae&scoped=true&"
import script from "./ApprovalCategory.vue?vue&type=script&lang=js&"
export * from "./ApprovalCategory.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCategory.vue?vue&type=style&index=0&id=e68c92ae&scoped=true&lang=less&"
import style1 from "./ApprovalCategory.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68c92ae",
  null
  
)

export default component.exports